// import { useState } from 'react'
// import AddItem from 'components/shared/AddItem'
import Box from 'components/shared/Box'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import CabanasCreator from 'routes/Upsell/CabanasCreator'
import { useGetProductQuery } from 'store/api-slice/hooks'
import { setInitialData } from 'store/cabana-slice'
import { useCabana } from 'store/cabana-slice/hooks'
import { useAppDispatch } from 'store/hooks'
import { useApp } from 'store/steps'
import CabanaTicket from './tickets/CabanaTicket'
import { CabanaReservation } from 'store/selfcare-slice/types'

interface ManageCabanasProps {
    tickets: CabanaReservation[]
}

const ManageCabanas = ({ tickets }: ManageCabanasProps) => {
    const dispatch = useAppDispatch()
    const { language } = useApp()

    const { getInitialDate } = useCabana(null)

    const { data: cabanaProductInfo, isFetching: isProductInfoFetching } =
        useGetProductQuery({
            _locale: language,
            productType: 'cabana',
        })

    useEffect(() => {
        if (isProductInfoFetching) return
        dispatch(
            setInitialData({
                productId: cabanaProductInfo?.productId || '',
                unitPrice: cabanaProductInfo?.unitPrice || 0,
            })
        )
    }, [isProductInfoFetching])

    useEffect(() => {
        dispatch(
            setInitialData({
                date: getInitialDate(),
            })
        )
    }, [])

    return (
        <Section id="manage-cabanas" hasSmallerSpacingsX hasSmallerSpacingsY>
            <Text variant="heading3" color="grayscale_900" mb={[24, 32]}>
                <FormattedMessage
                    id="selfcare.cabana.section_caption"
                    defaultMessage="Cabana (16+)"
                />
            </Text>
            <Box gap={[16, 24]} isFullWidth>
                {tickets.map((ticket, index) => (
                    <CabanaTicket
                        cabana={ticket}
                        key={ticket.original.detail.orderCabanaId}
                        index={index}
                    />
                ))}
            </Box>

            <CabanasCreator hasAltEditMode />
        </Section>
    )
}

export default ManageCabanas
